"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addressConfig", {
  enumerable: true,
  get: function get() {
    return _addressConfig.addressConfig;
  }
});
Object.defineProperty(exports, "ambassadorConfig", {
  enumerable: true,
  get: function get() {
    return _ambassadorConfig.ambassadorConfig;
  }
});
Object.defineProperty(exports, "conditionConfig", {
  enumerable: true,
  get: function get() {
    return _conditionConfig.conditionConfig;
  }
});
Object.defineProperty(exports, "contentConfig", {
  enumerable: true,
  get: function get() {
    return _contentConfig.contentConfig;
  }
});
Object.defineProperty(exports, "discoveryMethodConfig", {
  enumerable: true,
  get: function get() {
    return _discoveryMethodConfig.discoveryMethodConfig;
  }
});
Object.defineProperty(exports, "donationConfig", {
  enumerable: true,
  get: function get() {
    return _donationConfig.donationConfig;
  }
});
Object.defineProperty(exports, "educationConfig", {
  enumerable: true,
  get: function get() {
    return _educationConfig.educationConfig;
  }
});
Object.defineProperty(exports, "fieldsetConfig", {
  enumerable: true,
  get: function get() {
    return _fieldsetConfig.fieldsetConfig;
  }
});
Object.defineProperty(exports, "headerConfig", {
  enumerable: true,
  get: function get() {
    return _headerConfig.headerConfig;
  }
});
Object.defineProperty(exports, "heightSelectConfig", {
  enumerable: true,
  get: function get() {
    return _heightSelectConfig.heightSelectConfig;
  }
});
Object.defineProperty(exports, "heightWeightConfig", {
  enumerable: true,
  get: function get() {
    return _heightWeightConfig.heightWeightConfig;
  }
});
Object.defineProperty(exports, "listWithOtherConfig", {
  enumerable: true,
  get: function get() {
    return _listWithOtherConfig.listWithOtherConfig;
  }
});
Object.defineProperty(exports, "marketingPreferencesConfig", {
  enumerable: true,
  get: function get() {
    return _marketingPreferencesConfig.marketingPreferencesConfig;
  }
});
Object.defineProperty(exports, "medicalHistoryConfig", {
  enumerable: true,
  get: function get() {
    return _medicalHistoryConfig.medicalHistoryConfig;
  }
});
Object.defineProperty(exports, "motivationForJoiningConfig", {
  enumerable: true,
  get: function get() {
    return _motivationForJoiningConfig.motivationForJoiningConfig;
  }
});
Object.defineProperty(exports, "occupationConfig", {
  enumerable: true,
  get: function get() {
    return _occupationConfig.occupationConfig;
  }
});
Object.defineProperty(exports, "personCategoryConfig", {
  enumerable: true,
  get: function get() {
    return _personCategoryConfig.personCategoryConfig;
  }
});
Object.defineProperty(exports, "personalDetailsConfig", {
  enumerable: true,
  get: function get() {
    return _personalDetailsConfig.personalDetailsConfig;
  }
});
Object.defineProperty(exports, "phoneNumberConfig", {
  enumerable: true,
  get: function get() {
    return _phoneNumberConfig.phoneNumberConfig;
  }
});
Object.defineProperty(exports, "preQualifiersConfig", {
  enumerable: true,
  get: function get() {
    return _preQualifiersConfig.preQualifiersConfig;
  }
});
Object.defineProperty(exports, "reasonForDonatingConfig", {
  enumerable: true,
  get: function get() {
    return _reasonForDonatingConfig.reasonForDonatingConfig;
  }
});
Object.defineProperty(exports, "receivedBloodTransfusionConfig", {
  enumerable: true,
  get: function get() {
    return _receivedBloodTransfusionConfig.receivedBloodTransfusionConfig;
  }
});
Object.defineProperty(exports, "refusedBloodDonorConfig", {
  enumerable: true,
  get: function get() {
    return _refusedBloodDonorConfig.refusedBloodDonorConfig;
  }
});
Object.defineProperty(exports, "weightSelectConfig", {
  enumerable: true,
  get: function get() {
    return _weightSelectConfig.weightSelectConfig;
  }
});

var _addressConfig = require("../Address/addressConfig");

var _ambassadorConfig = require("../Ambassador/ambassadorConfig");

var _conditionConfig = require("../MedicalHistory/Condition/conditionConfig");

var _contentConfig = require("../Content/contentConfig");

var _discoveryMethodConfig = require("../DiscoveryMethod/discoveryMethodConfig");

var _donationConfig = require("../Donation/donationConfig");

var _educationConfig = require("../Education/educationConfig");

var _fieldsetConfig = require("../Fieldset/fieldsetConfig");

var _headerConfig = require("../Header/headerConfig");

var _heightWeightConfig = require("../HeightWeight/heightWeightConfig");

var _heightSelectConfig = require("../HeightWeight/HeightSelect/heightSelectConfig");

var _listWithOtherConfig = require("../ListWithOther/listWithOtherConfig");

var _marketingPreferencesConfig = require("../MarketingPreferences/marketingPreferencesConfig");

var _medicalHistoryConfig = require("../MedicalHistory/medicalHistoryConfig");

var _motivationForJoiningConfig = require("../MotivationForJoining/motivationForJoiningConfig");

var _occupationConfig = require("../Occupation/occupationConfig");

var _personalDetailsConfig = require("../PersonalDetails/personalDetailsConfig");

var _personCategoryConfig = require("../PersonCategory/personCategoryConfig");

var _receivedBloodTransfusionConfig = require("../MedicalHistory/ReceivedBloodTransfusion/receivedBloodTransfusionConfig");

var _refusedBloodDonorConfig = require("../MedicalHistory/RefusedBloodDonor/refusedBloodDonorConfig");

var _phoneNumberConfig = require("../PhoneNumber/phoneNumberConfig");

var _preQualifiersConfig = require("../PreQualifiers/preQualifiersConfig");

var _reasonForDonatingConfig = require("../ReasonForDonating/reasonForDonatingConfig");

var _weightSelectConfig = require("../HeightWeight/WeightSelect/weightSelectConfig");